
import { RouteObject } from 'react-router-dom';
import Home from '../pages/home/page';
import Trends from '../pages/trends/page';
import NotFound from '../pages/NotFound';

const routes: RouteObject[] = [
  {
    path: '/',
    element: <Home />,
  },
  {
    path: '/trends',
    element: <Trends />,
  },
  {
    path: '*',
    element: <NotFound />,
  },
];

export default routes;
